const __DEV__ = process.env.NODE_ENV === "development";

const altBackendUrl = __DEV__
  ? "http://localhost:9091"
  : "https://api.rep.guide";

export { altBackendUrl };
